import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint arrow-parens: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { defaultMemoize } from 'reselect';
import { compose } from 'recompose';
import cx from 'classnames';
import _noop from 'lodash/noop';
import _get from 'lodash/get';
import _castArray from 'lodash/castArray';
import _head from 'lodash/head';
import _identity from 'lodash/identity';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import FORM_ACTION_TYPES from '../../../../FormBuilder/constants/actionTypes';

// Components
import { Select } from '../../../../../molecules/advancedSelect';
import ActionsList from '../../../../../molecules/actionsList';

// Containers
import withFilterValue from '../../containers/withFilterValue';

// Helpers
import { getSingleValueStyles, getInputStylesInRem } from '../../../../../molecules/advancedSelect/styles/AdvancedSelect.styles';
import { getSelectedTypeFromValue, getSelectedOperatorFromValue, getOperatorOptionLabel, getOperatorOptionValue } from './helpers/filterListItem.general';
import { getRowActions } from './helpers/filterListItem.actions';

// Styles
import s from './filterListItem.module.scss';
var VISIBLE_ACTION_COUNT = 1;
var STYLE_OVERRIDES = {
  input: getInputStylesInRem,
  singleValue: getSingleValueStyles,
  menuPortal: function menuPortal(style) {
    return _objectSpread(_objectSpread({}, style), {}, {
      zIndex: 9999
    });
  }
};

/**
 * @typedef {object} Props
 * @prop {boolean} nonRemovable disables filter type input and removes delete option
 * @extends {React.Component<Props>}
 */
var FilterListItem = /*#__PURE__*/function (_Component) {
  _inherits(FilterListItem, _Component);
  var _super = _createSuper(FilterListItem);
  function FilterListItem(props) {
    var _this;
    _classCallCheck(this, FilterListItem);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "getTypeSelectValue", defaultMemoize(compose(_castArray, getSelectedTypeFromValue)));
    _defineProperty(_assertThisInitialized(_this), "getOperatorSelectValue", defaultMemoize(compose(_castArray, getSelectedOperatorFromValue)));
    _defineProperty(_assertThisInitialized(_this), "getRowActions", defaultMemoize(getRowActions));
    _defineProperty(_assertThisInitialized(_this), "makeHandleChange", function (fieldKey) {
      var valueGetter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity;
      return function (updatedChanges) {
        var _this$props = _this.props,
          onAction = _this$props.onAction,
          currentValue = _this$props.value,
          id = _this$props.id;
        var value = _castArray(_get(updatedChanges, 'value', updatedChanges));
        onAction({
          type: FORM_ACTION_TYPES.ON_FIELD_CHANGE,
          payload: {
            id: id,
            value: _objectSpread(_objectSpread({}, currentValue), {}, _defineProperty({}, fieldKey, valueGetter(value))),
            fieldKey: fieldKey
          }
        });
      };
    });
    _defineProperty(_assertThisInitialized(_this), "handleFilterRowAction", function (actionId) {
      var _this$props2 = _this.props,
        onAction = _this$props2.onAction,
        id = _this$props2.id;
      onAction({
        type: actionId,
        payload: {
          id: id
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderTypes", function () {
      var _this$props3 = _this.props,
        types = _this$props3.types,
        _this$props3$value = _this$props3.value,
        value = _this$props3$value === void 0 ? EMPTY_OBJECT : _this$props3$value,
        getTypeLabel = _this$props3.getTypeLabel,
        getTypeValue = _this$props3.getTypeValue,
        isDefaultFilterRow = _this$props3.isDefaultFilterRow,
        isDisabled = _this$props3.isDisabled,
        nonRemovable = _this$props3.nonRemovable;
      var selectedType = _this.getTypeSelectValue(value);
      var isTypeChangeDisabled = isDefaultFilterRow || isDisabled || nonRemovable;
      return /*#__PURE__*/React.createElement(Select, {
        options: types,
        onChange: _this.handleTypeChange,
        value: selectedType,
        className: s.field,
        classNamePrefix: "field",
        getOptionLabel: getTypeLabel,
        getOptionValue: getTypeValue,
        isDisabled: isTypeChangeDisabled,
        menuPortalTarget: document.body,
        styleOverrides: STYLE_OVERRIDES
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderOperators", function () {
      var _this$props4 = _this.props,
        operators = _this$props4.operators,
        _this$props4$value = _this$props4.value,
        value = _this$props4$value === void 0 ? EMPTY_OBJECT : _this$props4$value,
        isDefaultFilterRow = _this$props4.isDefaultFilterRow,
        isDisabled = _this$props4.isDisabled;
      var selectedOperator = _this.getOperatorSelectValue(value);
      return /*#__PURE__*/React.createElement(Select, {
        options: operators,
        onChange: _this.handleOperatorChange,
        value: selectedOperator,
        className: s.field,
        classNamePrefix: "field",
        getOptionValue: getOperatorOptionValue,
        getOptionLabel: getOperatorOptionLabel,
        isDisabled: isDefaultFilterRow || isDisabled,
        menuPortalTarget: document.body,
        styleOverrides: STYLE_OVERRIDES
      });
    });
    _defineProperty(_assertThisInitialized(_this), "renderTypeValue", function () {
      var _this$props5 = _this.props,
        TypeValue = _this$props5.valueComponent,
        baseProps = _this$props5.baseProps,
        isCheckFieldExistenceSelected = _this$props5.isCheckFieldExistenceSelected,
        isDisabled = _this$props5.isDisabled;
      if (!TypeValue || isCheckFieldExistenceSelected) {
        return null;
      }
      return /*#__PURE__*/React.createElement(TypeValue
      // Values will be provided by baseProps as different Component will have different value prop
      , _extends({}, baseProps, {
        onChange: _this.handleTypeValueChange,
        className: cx(s.field, s.typeValueField, baseProps.className),
        menuPortalTarget: document.body,
        styleOverrides: STYLE_OVERRIDES,
        disabled: isDisabled
      }));
    });
    _this.handleTypeChange = _this.makeHandleChange('type', _head);
    _this.handleOperatorChange = _this.makeHandleChange('operator', _head);
    _this.handleTypeValueChange = _this.makeHandleChange('values');
    return _this;
  }
  _createClass(FilterListItem, [{
    key: "renderActions",
    value: function renderActions() {
      var _this$props6 = this.props,
        isDefaultFilterRow = _this$props6.isDefaultFilterRow,
        isDisabled = _this$props6.isDisabled,
        nonRemovable = _this$props6.nonRemovable;
      var actions = this.getRowActions(isDefaultFilterRow, isDisabled, nonRemovable);
      return /*#__PURE__*/React.createElement(ActionsList, {
        actions: actions,
        onActionClick: this.handleFilterRowAction,
        visibleActionCount: VISIBLE_ACTION_COUNT
      });
    }
  }, {
    key: "render",
    value: function render() {
      var hideFilter = this.props.hideFilter;
      if (hideFilter) {
        return null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: s.container
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex"
      }, this.renderTypes(), this.renderOperators(), this.renderTypeValue()), this.renderActions());
    }
  }]);
  return FilterListItem;
}(Component);
FilterListItem.propTypes = {
  baseProps: PropTypes.object,
  getTypeLabel: PropTypes.func.isRequired,
  getTypeValue: PropTypes.func.isRequired,
  id: PropTypes.string,
  onAction: PropTypes.func,
  operators: PropTypes.array,
  types: PropTypes.array,
  value: PropTypes.object,
  valueComponent: PropTypes.element,
  isDefaultFilterRow: PropTypes.bool,
  hideFilter: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isCheckFieldExistenceSelected: PropTypes.bool,
  nonRemovable: PropTypes.bool
};
FilterListItem.defaultProps = {
  baseProps: EMPTY_OBJECT,
  id: '',
  onAction: _noop,
  operators: EMPTY_ARRAY,
  types: EMPTY_ARRAY,
  value: EMPTY_OBJECT,
  valueComponent: null,
  isDefaultFilterRow: false,
  hideFilter: false,
  isDisabled: false,
  isCheckFieldExistenceSelected: false,
  nonRemovable: false
};
export default withFilterValue(FilterListItem);